import {Component, EventEmitter, Input, Output, } from '@angular/core';
import {Router} from '@angular/router';
import {environmentBase} from '../../../../environments/environment.base';
import * as _ from 'lodash';

import {SearchResultsRowComponent} from 'shared/search/search-results/search-results-row/search-results-row.component';


@Component({
  moduleId: module.id,
  selector: 'export-manager-search-results-row',
  templateUrl: 'export-manager-search-results-row.component.html',
  styleUrls: ['export-manager-search-results-row.component.scss']
})
export class ExportManagerSearchResultsRowComponent extends SearchResultsRowComponent {

  @Input() declare timezone: any;
  @Output() downloadClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() receiversClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected router: Router,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get isCompleted(): boolean {
     return _.find(_.get(this.row, 'download'), ['completed', true]);
   }

   get backendUrl(): string {
     return environmentBase.BACKEND;
   }

   get isLinkActive(): boolean {
     const isItemSearchOnly = _.has(this.row, 'download') && this.row.download.length === 1 && this.row.download[0].export_type_id === 9;
     return this.isCompleted && !isItemSearchOnly;
   }

   get isDownloadFailed(): boolean {
     return _.find(_.get(this.row, 'download'), 'has_error') || _.find(_.get(this.row, 'download'), 'has_xsd_errors');
   }

   get isWarningErrorLevel(): boolean {
     return !!_.find(_.get(this.row, 'download'), (item) => item.error_level && item.error_level === 2);
   }

   get isReceiversSending(): boolean {
     return !!_.find(this.receivers, (receiver: any) => {
       return (!receiver.status || receiver.status === 200 || receiver.status === 300);
      });
   }

   get receivers(): any[] {
     return _.get(this.row, 'receivers_data');
   }

   get hasReceiversSentError(): boolean {
     return !!_.find(this.receivers, (receiver: any) => {
       return (receiver.status && (receiver.status === 400 || receiver.status === 600));
      });
   }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onLinkClick($event: any) {
    if (_.get($event, 'column.link', false)) {
      if ($event.column.col === 'receivers') {
        this.receiversClick.emit(this.receivers);
      }
    }
  }

  onDownloadClick() {
    this.downloadClick.emit(this.row);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private isInactive(name: string) {
    if (name.indexOf('PIES') >= 0) {
      // items
      return this.row.item_count === 0;
    } else if (name.indexOf('ITEMS') >= 0) {
      // items
      return this.row.item_count === 0;
    } else if (name.indexOf('ACES') >= 0) {
      // fitments
      return this.row.app_count === 0;
    } else if (name.indexOf('FITMENTS') >= 0) {
      // fitments
      return this.row.app_count === 0;
    }
    // assets
    return this.row.asset_count === 0;
  }
}
